import { useGlobal } from '../contexts/GlobalContext';

const TopBar = ({ isVisible, content, bgColor }) => {
  const { parse } = useGlobal();
  if (!isVisible) return null;
  const topBarStyle = {
    backgroundColor: bgColor
};

  return (
    <div className={`w-full py-3 px-4 text-center text-white text-sm font-medium relative z-50`} style={topBarStyle}>
      <div className="max-w-content mx-auto">
        <div className="topbar-content">
          {parse(content)}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
